import React from 'react';

interface CherryIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const CherryIcon: React.FC<CherryIconProps> = ({
  className = '',
  size = 24,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.16016 3C11.7827 3 15.6988 6.012 17.0605 
      10.1797C19.4199 10.799 21.1601 12.9464 21.1602 
      15.5C21.1602 18.5376 18.6977 21 15.6602 21C14.702 
      21 13.8011 20.755 13.0166 20.3242C14.333 19.1347 
      15.1602 17.4139 15.1602 15.5C15.1601 13.5861 14.333 
      11.8653 13.0166 10.6758C13.5833 10.3646 14.211 10.1516 
      14.877 10.0566C14.3114 8.75952 13.4294 7.63307 12.3271 
      6.77441C12.1418 8.07702 11.668 9.34516 10.9111 10.4814C12.8261 
      11.3417 14.1601 13.2646 14.1602 15.5C14.1602 18.5376 11.6977 
      21 8.66016 21C5.62259 21 3.16016 18.5376 3.16016 15.5C3.1602 12.4625 
      5.62262 10 8.66016 10C8.69867 10 8.73707 10.0012 8.77539 10.002C9.83443 
      8.74462 10.3808 7.20513 10.4141 5.65234C9.41303 5.23232 8.31375 5 7.16016 5C6.60787 
      5 6.16016 4.55229 6.16016 4C6.16016 3.44771 6.60787 3 7.16016 3ZM7.61133 12.1221C7.49272 
      11.8729 7.19461 11.7664 6.94531 11.8848C5.75926 12.4482 4.89341 13.5791 
      4.7002 14.9287C4.66109 15.2021 4.85165 15.456 5.125 15.4951C5.39828 15.5341 
      5.65134 15.3436 5.69043 15.0703C5.835 14.0609 6.48399 13.2114 7.375 
      12.7881C7.62415 12.6695 7.72976 12.3714 7.61133 12.1221Z"
      fill={color}
    />
  </svg>
);

export default CherryIcon;
